
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetoharihareshwertaxi() {



    const cardData =
    {
        keyword: 'Pune to Harihareshwar Taxi ',
        heading: 'Morya Cabs: Pune to Harihareshwar Taxi ',
        headingDescription: 'Morya Cabs offers reliable, comfortable, and affordable taxi services from Pune to Harihareshwar. Whether you are visiting for a spiritual retreat or a peaceful beach vacation, our professional drivers and well-maintained fleet ensure a smooth, hassle-free journey. The distance from Pune to Harihareshwar is approximately 170-190 km, and the drive usually takes around 4 to 5 hours by road. Enjoy a comfortable ride with premium amenities and excellent customer service.',

        top: 'Top Places to Visit in Harihareshwar with Morya Cabs:',

"topPlaces": [
    {
        "title": "Harihareshwar Temple",
        "description": "The main attraction in Harihareshwar, this ancient temple is dedicated to Lord Shiva. It is revered for its spiritual significance and offers a tranquil atmosphere for worshippers and visitors alike."
    },
    {
        "title": "Harihareshwar Beach",
        "description": "A peaceful and less crowded beach, perfect for relaxing and enjoying the serene beauty of the Arabian Sea. The beach is known for its clean, golden sands and calm waters."
    },
    {
        "title": "Kalbhairav Temple",
        "description": "Located near Harihareshwar Temple, this historic temple is dedicated to Lord Shiva. It is known for its religious significance and peaceful ambiance, making it a must-visit for devotees."
    },
    {
        "title": "Bhagwati Mandir",
        "description": "Situated near Harihareshwar Temple, Bhagwati Mandir is dedicated to Goddess Bhagwati. It holds great religious and cultural importance in the region."
    },
    {
        "title": "Shrivardhan Beach",
        "description": "Located close to Harihareshwar, this beautiful beach offers stunning views and a relaxing atmosphere. Known for its clean surroundings, it is ideal for a quiet day by the sea."
    },
    {
        "title": "Ashishnath Mandir",
        "description": "A small but revered temple near Harihareshwar, Ashishnath Mandir is dedicated to Lord Vishnu. It provides a calm and serene environment for spiritual seekers."
    },
    {
        "title": "Velas Beach",
        "description": "About a 30-minute drive from Harihareshwar, Velas Beach is known for its natural beauty and the annual turtle festival, where olive ridley turtles lay their eggs."
    },
    {
        "title": "Harihareshwar Hill",
        "description": "For adventure lovers, Harihareshwar Hill offers a scenic trek with breathtaking views of the surrounding area, including the beach and temples. A great spot for nature lovers and photographers."
    },
    {
        "title": "Aravi Beach",
        "description": "A secluded and serene beach near Harihareshwar, Aravi Beach is ideal for visitors looking to escape the crowds and enjoy some solitude by the sea."
    },
    {
        "title": "Tungarli Lake",
        "description": "Located a short drive from Harihareshwar, Tungarli Lake is a perfect spot for a nature walk or a peaceful picnic, offering a refreshing and relaxing environment."
    }
],


"services": [
    {
      "name": "Pune to Harihareshwar Taxi Fare",
      "description": "Morya Cab offers competitive and transparent taxi fares for your journey from Pune to Harihareshwar. We ensure that our fares are affordable while providing a comfortable ride."
    },
    {
      "name": "Pune to Harihareshwar Cab Charges",
      "description": "Morya Cab provides clear and upfront cab charges for your journey to Harihareshwar. Enjoy a smooth and worry-free ride without any hidden costs."
    },
    {
      "name": "Pune to Harihareshwar Taxi Booking",
      "description": "Booking a taxi from Pune to Harihareshwar is simple and convenient with Morya Cab. You can book online or via phone to ensure a hassle-free travel experience."
    },
    {
      "name": "Pune to Harihareshwar Car Rental",
      "description": "Morya Cab offers car rental services from Pune to Harihareshwar, with a wide range of well-maintained vehicles to suit your needs. Travel comfortably at your own pace."
    },
    {
      "name": "Pune to Harihareshwar Taxi Rates",
      "description": "Morya Cab offers competitive and transparent taxi rates for your trip from Pune to Harihareshwar. Enjoy affordable rates without compromising on quality and comfort."
    },
    {
      "name": "Pune to Harihareshwar Cab Pricing",
      "description": "Morya Cab provides clear and upfront pricing for your Pune to Harihareshwar trip. Our competitive prices ensure you get the best value for your journey."
    },
    {
      "name": "Pune to Harihareshwar Private Car Hire",
      "description": "For a private and comfortable experience, Morya Cab offers private car hire services for your trip from Pune to Harihareshwar. Travel in comfort and privacy with our well-maintained vehicles."
    },
    {
      "name": "Pune to Harihareshwar Cab Cost",
      "description": "Morya Cab offers affordable and transparent cab costs for your Pune to Harihareshwar journey. No hidden fees, just a straightforward pricing structure for your peace of mind."
    },
    {
      "name": "Pune to Harihareshwar Taxi Service Charges",
      "description": "Morya Cab provides clear taxi service charges for your trip to Harihareshwar. We guarantee no hidden charges and a comfortable, professional service."
    },
    {
      "name": "Pune to Harihareshwar Travel Fare",
      "description": "For a fair and transparent travel fare, Morya Cab ensures you have a clear understanding of the cost for your journey from Pune to Harihareshwar. Travel without any surprises."
    },
    {
      "name": "Pune to Harihareshwar by Car",
      "description": "Morya Cab offers comfortable and reliable car services from Pune to Harihareshwar. Travel in style with our well-maintained cars and professional drivers."
    },
    {
      "name": "Pune to Harihareshwar Innova Cab",
      "description": "For a premium experience, Morya Cab offers Innova cabs for your journey from Pune to Harihareshwar. Enjoy comfort and space during your trip with our luxury vehicles."
    },
    {
      "name": "Pune to Harihareshwar Innova Crysta",
      "description": "Morya Cab provides Innova Crysta cabs for your Pune to Harihareshwar journey. Experience ultimate comfort with extra space and luxury on your trip."
    },
    {
      "name": "Pune to Konkan Darshan Taxi",
      "description": "Morya Cab offers specialized Konkan darshan taxi services. Travel from Pune to Harihareshwar and explore the beautiful Konkan coast with our well-maintained vehicles and professional drivers."
    },
    {
      "name": "Pune to Harihareshwar Tempo Traveller on Rent",
      "description": "For a group journey, Morya Cab offers tempo travellers for rent. Whether you're traveling with family or friends, our spacious tempo travellers are the perfect option for your Pune to Harihareshwar trip."
    },
    {
      "name": "Pune to Harihareshwar Swift Dzire on Rent",
      "description": "Morya Cab offers Swift Dzire cars for rent from Pune to Harihareshwar. Ideal for small groups, enjoy comfort and style with a Swift Dzire at an affordable price."
    },
    {
      "name": "Pune to Harihareshwar Kia Carens on Rent",
      "description": "Morya Cab provides Kia Carens for rent for your trip to Harihareshwar. Enjoy a comfortable and spacious journey with this premium vehicle."
    },
    {
      "name": "Pune to Harihareshwar Mini Bus on Rent",
      "description": "For larger groups, Morya Cab offers mini bus rental services for your Pune to Harihareshwar trip. Choose from various sizes, including a 17-seater and 20-seater, to accommodate your entire group."
    },
    {
      "name": "Pimpri Chinchwad to Harihareshwar Cab",
      "description": "Morya Cab also provides reliable cab services from Pimpri Chinchwad to Harihareshwar. Enjoy a comfortable, hassle-free ride to your destination with our professional drivers and well-maintained vehicles."
    }
  ],


  tableData: [
    ["Pune to Harihareshwar Taxi Fare", "-Pune to Harihareshwar Cab Charges"],
    ["Pune to Harihareshwar Taxi Booking", "-Pune to Harihareshwar Car Rental"],
    ["Pune to Harihareshwar Taxi Rates", "-Pune to Harihareshwar Cab Pricing"],
    ["Pune to Harihareshwar Private Car Hire", "-Pune to Harihareshwar Cab Cost"],
    ["Pune to Harihareshwar Taxi Service Charges", "-Pune to Harihareshwar Travel Fare"],
    ["Pune to Harihareshwar by car", "-Pune to Harihareshwar Innova Cab"],
    ["Pune to Harihareshwar Innova Crysta", "-Pune to Konkan Darshan Taxi"],
    ["Pune to Harihareshwar Tempo Traveller on Rent", "-Pune to Harihareshwar Swift Dzire on Rent"],
    ["Pune to Harihareshwar Kia Carens on Rent", "-Pune to Harihareshwar Mini Bus on Rent"],
    ["Pimpri Chinchwad to Harihareshwar Cab", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we understand the importance of time. Whether you're traveling for a peaceful spiritual trip, a family vacation, or a weekend getaway to Harihareshwar, our drivers ensure timely pickups and smooth drop-offs, making your journey hassle-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of vehicles, including sedans, SUVs, and premium cars, all designed for comfort during long trips. With air conditioning, spacious interiors, and ample legroom, we ensure that your ride to Harihareshwar is as comfortable as possible."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced in long-distance travel and are familiar with the best routes to Harihareshwar. Their professionalism ensures a smooth, safe, and comfortable journey for you and your loved ones."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab provides competitive and transparent pricing for the Pune to Harihareshwar trip. We offer upfront pricing with no hidden charges, so you know exactly what to expect before you begin your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking to ensure a safe and secure ride to Harihareshwar."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab is available 24/7. Whether you need an early morning departure or a late-night return, our team is ready to serve your travel needs, making your trip as convenient as possible."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your taxi for Pune to Harihareshwar is easy with Morya Cab. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer customized travel packages to suit your needs. Whether you’re going for a religious visit or leisure, we can tailor your journey to make it special and memorable."
    }
]











    }

    const faqData = [
        {
          question: "How can I book a taxi from Pune to Harihareshwar with Morya Cab?",
          answer: "You can book a taxi easily through our website, mobile app, or contact our customer service team for assistance."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all our drivers are experienced and skilled in handling long-distance travel, ensuring a smooth and safe journey to Harihareshwar."
        },
        {
          question: "What types of vehicles are available for the Pune to Harihareshwar trip?",
          answer: "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, all designed for comfort and convenience during long trips."
        },
        {
          question: "How do I pay for my Pune to Harihareshwar taxi rental?",
          answer: "We offer flexible payment options, including cash, credit/debit cards, and online payments via our app for your convenience."
        },
        {
          question: "Can I book a round trip from Pune to Harihareshwar?",
          answer: "Yes, round trips are available. Simply provide us with the details of your return journey, and we’ll take care of the rest."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, such as for waiting time or detours, will be communicated to you upfront, ensuring full transparency in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Harihareshwar?",
          answer: "Yes, we offer sightseeing trips in and around Harihareshwar, so you can explore its famous beaches and temples in comfort."
        },
        {
          question: "What is the luggage allowance for a Pune to Harihareshwar taxi?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, kindly inform us during booking, and we’ll arrange accordingly."
        },
        {
          question: "Is Morya Cab available for corporate travel to Harihareshwar?",
          answer: "Yes, we offer corporate travel services, including group trips and business-related visits, to Harihareshwar with professional drivers and vehicles."
        },
        {
          question: "Why should I choose Morya Cab for Pune to Harihareshwar travel?",
          answer: "Morya Cab ensures a comfortable, safe, and reliable journey with professional drivers, transparent pricing, and well-maintained vehicles, making it the best choice for your trip."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Anil Verma',
          role: 'Traveler',
          review: "We had a fantastic experience with Morya Cab for our trip to Harihareshwar. The vehicle was clean and spacious, and the driver was very courteous and professional. Highly recommend!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Priya Shinde',
          role: 'Traveler',
          review: "Our family enjoyed the trip to Harihareshwar, thanks to Morya Cab. The driver was punctual, the car was comfortable, and we had a smooth ride all the way. Will definitely book again for our next trip!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    
    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "CarRental",
        "name": "Pune to Harihareshwar Taxi Service",
        "description": "Affordable taxi services from Pune to Harihareshwar, providing comfortable and reliable rides for a perfect trip. Enjoy easy booking for one-way or round-trip travel.",
        "provider": {
          "@type": "Organization",
          "name": "Pune Taxi Services",
          "url": "https://www.punetaxiservices.com",
          "telephone": "+91-9999999999",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Shop No. 22, Pune City Mall, Pune",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411003",
            "addressCountry": "IN"
          }
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": 4000,
          "eligibleRegion": {
            "@type": "Place",
            "name": "Pune"
          },
          "priceValidUntil": "2025-12-31",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "4000",
            "unitCode": "DAY",
            "description": "Taxi service from Pune to Harihareshwar per day"
          }
        },
        "keywords": "Pune to Harihareshwar Taxi Fare, Pune to Harihareshwar Cab Charges, Pune to Harihareshwar Taxi Booking, Pune to Harihareshwar Car Rental, Pune to Harihareshwar Taxi Rates, Pune to Harihareshwar Cab Pricing, Pune to Harihareshwar Private Car Hire, Pune to Harihareshwar Cab Cost, Pune to Harihareshwar Taxi Service Charges, Pune to Harihareshwar by Car, Pune to Harihareshwar Innova Cab, Pune to Harihareshwar Innova Crysta, Pune to Konkan Darshan Taxi, Pune to Harihareshwar Tempo Traveller, Pune to Harihareshwar Swift Dzire, Pune to Harihareshwar Kia Carens, Pune to Harihareshwar Mini Bus on Rent"
      };
      

    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Pune to Harihareshwar Taxi Service | Affordable and Comfortable Ride | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Affordable taxi services from Pune to Harihareshwar, providing comfortable and reliable rides for a perfect trip. Enjoy easy booking for one-way or round-trip travel."
  />
  <meta
    name="keywords"
    content="Pune to Harihareshwar Taxi Fare, Pune to Harihareshwar Cab Charges, Pune to Harihareshwar Taxi Booking, Pune to Harihareshwar Car Rental, Pune to Harihareshwar Taxi Rates, Pune to Harihareshwar Cab Pricing, Pune to Harihareshwar Private Car Hire, Pune to Harihareshwar Cab Cost, Pune to Harihareshwar Taxi Service Charges, Pune to Harihareshwar by Car, Pune to Harihareshwar Innova Cab, Pune to Harihareshwar Innova Crysta, Pune to Konkan Darshan Taxi, Pune to Harihareshwar Tempo Traveller, Pune to Harihareshwar Swift Dzire, Pune to Harihareshwar Kia Carens, Pune to Harihareshwar Mini Bus on Rent"
  />
  <meta property="og:title" content="Pune to Harihareshwar Taxi Service | Affordable and Comfortable Ride" />
  <meta
    property="og:description"
    content="Affordable taxi services from Pune to Harihareshwar, providing comfortable and reliable rides for a perfect trip. Enjoy easy booking for one-way or round-trip travel."
  />
  <meta property="og:url" content="https://www.punetaxiservices.com" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://www.punetaxiservices.com/images/harihareshwar-taxi.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetoharihareshwertaxi;